import React, { DetailedHTMLProps, PropsWithChildren, useCallback, useEffect, useMemo, useRef } from 'react'
import ReactDOM from 'react-dom'
import { IoClose } from 'react-icons/io5'

const Modal = ( { open, children, onClickOutside, showCloseButton = true, onClickCloseButton }:Props ) => {

    const contentRef = useRef<HTMLDivElement>( null )

    const handleClick = useCallback( ( e:MouseEvent ) => {
        if( !contentRef.current || e.composedPath().includes( contentRef.current ) ) return
        onClickOutside && onClickOutside()
    }, [ contentRef, onClickOutside ] )

    useEffect( () => {
        document.addEventListener( 'click', handleClick )
        return () => document.removeEventListener( 'click', handleClick )
    }, [ handleClick ] )

    const body = useMemo( () => {
        return document.querySelector( 'body' )
    }, [ ] )

    return (
        !open || !body ? <></> :
        ReactDOM.createPortal( (
            <div className="fixed top-0 left-0 z-50 h-screen w-screen bg-gray-900 bg-opacity-75 flex items-center justify-center px-2 py-14">
                <div
                    ref={ contentRef }
                    className="bg-white rounded-md pt-0 relative overflow-hidden max-h-full flex flex-col justify-start"
                >
                    {
                        showCloseButton &&
                        <span className="bg-white text-xl absolute top-4 right-4 cursor-pointer flex items-center justify-end" onClick={ onClickCloseButton } >
                            <IoClose />
                        </span>
                    }
                    <div className="flex-1 overflow-auto p-8">
                        { children }
                    </div>
                </div>
            </div>
        ), body )
    )
}

interface Props extends DetailedHTMLProps<PropsWithChildren<any>, HTMLDivElement>{
    open?: boolean,
    onClickOutside?: () => void,
    onClickCloseButton?: () => void,
    showCloseButton?: boolean
}

export default Modal
